import { StyledButton } from "./button.style";
import type { ButtonProps } from "./button.type";

export const Button = ({ iconNamed, iconSized = 16, children, ...props }: ButtonProps) => {
    return (
        <StyledButton {...props}>
            {iconNamed && (
                <span
                    className="material-icons-outlined"
                    style={{
                        fontSize: `${iconSized}px`,
                    }}
                >
                    {iconNamed}
                </span>
            )}
            {props.size !== "small" && children}
        </StyledButton>
    );
};

export const ButtonSystem = () => {};
